module.exports = __webpack_public_path__ + "static/oflineMap-c93c76b27d9a2214abcd54aa9d8d5677.jpg";